module.exports = __webpack_public_path__ + "static/media/wall-elgeemedeerei.62931079.png";